import initialState from "./InitialState"
import {GET_ALL_PATIENTS_FOR_SEGMENT_MP} from "../actions/ActionTypes";

export const ManagedPlanPatientsReducer = (state = initialState.mpPatientsData, action: any) => {
    switch (action.type) {
        case GET_ALL_PATIENTS_FOR_SEGMENT_MP:
            return [...action.payload]
        default:
            return state
    }
}